import React, { useState } from "react";
import { Card, Dropdown, Row, Col, Button } from "react-bootstrap";
import { FiCalendar, FiVideo, FiSettings } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const interviewsData = {
  Today: [
    {
      title: "UI/UX Design Interview",
      time: "12:00 PM - 01:50 PM",
      border: "#ff6b2c",
      avatars: [
        "/assets/img/users/user-31.jpg",
        "/assets/img/users/user-32-1.jpg",
        "/assets/img/users/user-29-1.jpg",
        "/assets/img/users/user-56.jpg"
      ],
      extra: 9
    },
    {
      title: "Senior Developer React",
      time: "03:00 PM - 04:00 PM",
      border: "#1f5a67",
      avatars: [
        "/assets/img/users/user-39.jpg",
        "/assets/img/users/user-41.jpg",
        "/assets/img/users/user-44-1.jpg"
      ],
      extra: 4
    }
  ],

  Weekly: [
    {
      title: "NodeJS Interview",
      time: "11:00 AM - 12:00 PM",
      border: "#ff6b2c",
      avatars: [
        "/assets/img/users/user-31.jpg",
        "/assets/img/users/user-29-1.jpg"
      ],
      extra: 2
    }
  ],

  Yearly: [
    {
      title: "Architecture Interview",
      time: "02:00 PM - 03:00 PM",
      border: "#1f5a67",
      avatars: [
        "/assets/img/users/user-41.jpg",
        "/assets/img/users/user-44-1.jpg"
      ],
      extra: 5
    }
  ]
};

export default function UpcomingInterviews() {

  const [filter, setFilter] = useState("Today");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const data = interviewsData[filter];

  return (
    <>
      <style>{`

      .up-card{
        border-radius:12px;
        border:1px solid #e5e7eb;
      }

      .up-header{
        border:1px solid #e5e7eb;
        border-left:4px solid #ff6b2c;
        border-radius:8px;
        padding:12px 14px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:20px;
      }

      .up-title{
        font-size:18px;
        font-weight:600;
      }

      .gear-btn{
        background:#ff6b2c;
        color:white;
        border:none;
        width:40px;
        height:40px;
        border-radius:6px;
        display:flex;
        align-items:center;
        justify-content:center;
      }

      .interview-card{
        border:1px solid #e5e7eb;
        border-radius:8px;
        padding:16px;
        margin-bottom:15px;
        position:relative;
      }

      .avatar-stack img{
        width:34px;
        height:34px;
        border-radius:50%;
        border:3px solid white;
        margin-left:-10px;
      }

      .extra-avatar{
        width:34px;
        height:34px;
        border-radius:50%;
        background:#f3f4f6;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:13px;
        margin-left:-10px;
        border:2px solid white;
      }

.view-btn{
  border:1px solid #e5e7eb;
  background:#f9fafb;
  border-radius:8px;
  padding:10px;
  transition: all 0.3s ease;
}

/* hover effect */
.view-btn:hover{
  background:#ff6b2c;
  color:white !important;
  border-color:#ff6b2c;
}

/* remove bootstrap blue focus */
.view-btn:focus{
  box-shadow:none !important;
}
      `}</style>

      <Card className="up-card h-100">

        <Card.Body className="d-flex flex-column justify-content-between">

          <div>

            {/* Header */}

            <div className="d-flex justify-content-between align-items-center">

              <div className="up-header flex-grow-1 me-2">

                <div className="up-title">
                  Upcoming Interview
                </div>

                <Dropdown>

                  <Dropdown.Toggle variant="light" className="border">
                    <FiCalendar className="me-2"/> {filter}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={()=>setFilter("Today")}>Today</Dropdown.Item>
                    <Dropdown.Item onClick={()=>setFilter("Weekly")}>Weekly</Dropdown.Item>
                    <Dropdown.Item onClick={()=>setFilter("Yearly")}>Yearly</Dropdown.Item>
                  </Dropdown.Menu>

                </Dropdown>

              </div>

              <button className="gear-btn">
                <FiSettings/>
              </button>

            </div>

            {/* Interview Cards */}

            {data.map((item,index)=>(
              <div
                key={index}
                className="interview-card"
                style={{borderLeft:`4px solid ${item.border}`}}
              >

                <div className="d-flex justify-content-between align-items-center mb-3">

                  <div>
                    <div style={{fontWeight:600}}>
                      {item.title}
                    </div>
                    <div style={{color:"#6b7280"}}>
                      {item.time}
                    </div>
                  </div>

                  <div className="avatar-stack d-flex align-items-center">

                    {item.avatars.map((a,i)=>(
                      <img key={i} src={a} alt=""/>
                    ))}

                    <div className="extra-avatar">
                      +{item.extra}
                    </div>

                  </div>

                </div>

                <Row>

                  <Col sm={7}>

                    <DatePicker
                      selected={selectedDate}
                      onChange={(date)=>setSelectedDate(date)}
                      customInput={
                        <Button variant="light" className="w-100 border">
                          <FiCalendar className="me-2"/>
                          Add to Calendar
                        </Button>
                      }
                    />

                  </Col>

                  <Col sm={5}>

                    <Button variant="light" className="w-100 border">
                      <FiVideo className="me-2"/>
                      Join Now
                    </Button>

                  </Col>

                </Row>

              </div>
            ))}

          </div>

          <Button className="view-btn text-dark">
            View All →
          </Button>

        </Card.Body>

      </Card>
    </>
  );
}